import { AspectRatio } from "@chakra-ui/react";
import { FillImage } from "components/images";
import React from "react";
import { remCalc } from "theme/utils";
import { ProductFeatures } from "ui/product-features";
import fullDiagram from "../../../../public/assets/solutions/financial-services/full-diagram.png";
import mobileDiagram1 from "../../../../public/assets/solutions/financial-services/mobile-diagram-1.png";
import mobileDiagram2 from "../../../../public/assets/solutions/financial-services/mobile-diagram-2.png";
import mobileDiagram3 from "../../../../public/assets/solutions/financial-services/mobile-diagram-3.png";

export function HightouchFeaturesOverview() {
  return (
    <ProductFeatures
      theme="dark"
      media={
        <AspectRatio ratio={1320 / 553} pos="relative" boxSize="100%" borderRadius="bigger" overflow="hidden">
          <FillImage
            src={fullDiagram}
            alt='An illustration of a diagram demonstrating the secure flow of data using Hightouch. On the left, there are three sources labeled "Website interactions, Online", "Internal systems, Online and offline", and "Accounts, Online". These are joined with lines to a central set of data marked with a lock icon, where there are three audiences defined: "Prospective users", "New accounts", and "High-risk accounts". Each audience is then securely connecting to an outgoing destination: "Prospective users" are used to "Target audience on Meta", "New accounts" are used to "Message customers via Iterable", and "High-risk accounts" are used to "Send alert in Slack to the account team".'
          />
        </AspectRatio>
      }
      mobileFeatureTextMinH={{ base: remCalc(128), sm: remCalc(108) }}
      productFeatures={[
        {
          id: "contracts",
          mobileImage: {
            src: mobileDiagram1,
            alt: 'An illustration of a portion of a diagram demonstrating the secure flow of data using Hightouch. There are three sources labeled "Website interactions - online", "Internal systems - online and offline", and "Accounts - online". These are joined with lines into a single stream of data',
          },
          title: "Collect trusted and compliant data",
          description:
            "Ensure that all incoming data is standardized and vetted before it’s ever stored, guaranteeing high-quality, compliant data from the start.",
          cta: {
            label: "Learn more about data contracts",
            href: "/blog/data-contracts-hightouch-events",
            variant: "primary",
          },
        },
        {
          id: "governance",
          mobileImage: {
            src: mobileDiagram2,
            alt: 'An illustration of a portion of a diagram demonstrating the secure flow of data using Hightouch. A single line of incoming data is marked with a lock icon, which flows into the three audiences defined: "Prospective users", "New accounts", and "High-risk accounts". Each audience has an outgoing line representing the flow of data to a destination.',
          },
          title: "Govern how your data gets used",
          description:
            "Centrally manage and oversee data access, usage, and compliance across your organization. Ensure compliance from the data layer at the center of all of your other tools.",
          cta: {
            label: "Learn more about data governance",
            href: "/platform/reverse-etl#data-governance",
            variant: "primary",
          },
        },
        {
          id: "marketing",
          mobileImage: {
            src: mobileDiagram3,
            alt: 'An illustration of a portion of a diagram demonstrating the secure flow of data using Hightouch. There are three lines of data coming in from the left. Each line feeds into a different destination: the first is to "Target audience on Meta", the second is to "Message customers via Iterable", and the last is to "Send alert in Slack to the account team".',
          },
          title: "Activate protected-class data securely",
          description:
            "Empower your marketing teams with self-service data access. Safely sync data from your warehouse to approved and compliant destinations.",
          cta: {
            label: "Learn how Hightouch supports marketing",
            href: "/solutions/marketing",
            variant: "primary",
          },
        },
      ]}
    />
  );
}
